import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "../../services/api";
import CommandePage from "../../core/commande/CommandePage";
import PatientForm from "../../components/PatientForm";
import { useAuth } from "../../auth/AuthContext";
import { PatientContactTable } from "./contacts/PatientContactTable";
import { FollowUpTable } from "./followUp/FollowUpTable";
import { MEDICAL_EQUIPMENT_MEDICAMENT_STRATEGY } from "./model/materielConstants";
import { EquipmentPark } from "./park/EquipmentPark";
import { SupplierTable } from "./suppliers/SupplierTable";

// Service matériel médical : boîte mail des commandes, tableau de suivi, parc, contacts patients et fournisseurs.
export default function MaterielMedical() {
    const { serviceKey: routeServiceKey } = useParams();
    const { user } = useAuth();
    const [tab, setTab] = useState("mail");
    const [service, setService] = useState(null);
    const serviceKey = routeServiceKey || "MEDICAL_EQUIPMENT";

    useEffect(() => {
        API.get("/admin/services", { noRedirectOn401: true })
            .then(res => {
                const found = (res.data || []).find(item => item.serviceKey === serviceKey);
                setService(found || { name: "Matériel médical", serviceKey, type: "MEDICAL_EQUIPMENT" });
            })
            .catch(() => setService({ name: "Matériel médical", serviceKey, type: "MEDICAL_EQUIPMENT" }));
    }, [serviceKey]);

    const mailContext = useMemo(() => ({
        serviceKey,
        noPharmaceuticalValidation: true,
        lockStatut: true,
        showStatut: false,
        showStatutFilter: false,
        medicamentStrategy: MEDICAL_EQUIPMENT_MEDICAMENT_STRATEGY,
    }), [serviceKey]);

    return (
        <div style={{ height: "100%", display: "flex", flexDirection: "column", background: "white" }}>
            <div style={{ padding: "12px 18px 0", borderBottom: "1px solid #e5e7eb", flexShrink: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <h1 style={{ fontSize: "18px", margin: 0, color: "#111827" }}>{service?.name || "Service"}</h1>
                    <div style={{ flex: 1 }} />
                    {[
                        ["mail", "Boîte mail"],
                        ["follow", "Tableau de suivi"],
                        ["park", "Parc matériel"],
                        ["contacts", "Contact Patient"],
                        ["suppliers", "Fournisseurs"],
                    ].map(([key, label]) => (
                        <button
                            key={key}
                            onClick={() => setTab(key)}
                            style={{
                                padding: "9px 14px",
                                border: 0,
                                borderBottom: tab === key ? "2px solid #2563eb" : "2px solid transparent",
                                background: "transparent",
                                color: tab === key ? "#1d4ed8" : "#64748b",
                                fontWeight: tab === key ? 700 : 500,
                                cursor: "pointer",
                            }}
                        >
                            {label}
                        </button>
                    ))}
                </div>
            </div>
            <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
                {tab === "mail" ? (
                    <CommandePage context={mailContext}>
                        {({ draft, setDraft, save, isDirty }) => (
                            <PatientForm
                                patients={draft?.patients || []}
                                ehpadId={draft?.ehpadId}
                                medicamentStrategy={MEDICAL_EQUIPMENT_MEDICAMENT_STRATEGY}
                                onChange={(patients) => setDraft(prev => ({ ...prev, patients }))}
                                onSave={save}
                                isDirty={isDirty}
                            />
                        )}
                    </CommandePage>
                ) : tab === "follow" ? (
                    <FollowUpTable serviceKey={serviceKey} isSuperAdmin={user?.role === "SUPER_ADMIN"} />
                ) : tab === "park" ? (
                    <EquipmentPark serviceKey={serviceKey} />
                ) : tab === "suppliers" ? (
                    <SupplierTable serviceKey={serviceKey} />
                ) : (
                    <PatientContactTable serviceKey={serviceKey} />
                )}
            </div>
        </div>
    );
}
